import React from 'react';
import cn from 'classnames';
import { RowLayout, types } from './RowLayout';
import styles from './index.module.scss';

const emptyArr = [];
const isDisabledDefault = () => false;

const IntervalSetupList = ({
  rootClass,
  intervalFields = emptyArr,
  renderRowStart,
  renderRowMiddle,
  renderRowEnd,
  rowType = types.classic,
  isRowBodyDisabled = isDisabledDefault,
  isRowDisabled = isDisabledDefault,
}) => {
  return (
    <ul className={cn(styles.root, rootClass)}>
      {intervalFields.map((field, index) => {
        return (
          <RowLayout
            key={field.id}
            index={index}
            field={field}
            renderStart={renderRowStart}
            renderMiddle={renderRowMiddle}
            renderEnd={renderRowEnd}
            setupType={rowType}
            bodyDisabled={isRowBodyDisabled({ field, index })}
            disabled={isRowDisabled({ field, index })}
          />
        );
      })}
    </ul>
  );
};

IntervalSetupList.rowTypes = types;

export default IntervalSetupList;
